import Type from "./../../Global/Typography.js";
import React, { lazy } from "react";
import styled from "styled-components";
import BaseComponent from "./../../BaseComponent.js";

// Components
import NanoFlex from "./../../Global/NanoFlex.js";
import SimpleButton from "../../Buttons/SimpleButton.js";
import Input from "../../Forms/Input.js";
import MultipleSelectionDropdown from "../../Forms/MultipleSelectionDropdown.js";

// ICONS
import { ReactComponent as SearchIcon } from "./../../Global/icons/search.svg";
import { ReactComponent as LocationIcon } from "./../../Global/icons/locationPin.svg";

//Services
import recruitmentRequestService from "../../../services/RecruitmentRequestService.js";

const StyledRecruitment = styled(NanoFlex)`
  padding: 0 50px;
  gap: 124px;

  @media only screen and (max-width: 815px) {
    gap: 84px;
  }

  .chaseUpLoading {
    height: 100px;

    img {
      height: 100px;
      width: 200px;
    }
  }

  .recruitmentHeader {
    height: 400px;
    background: ${(props) => props.theme.color.primaryColors.mediumPurple};
    gap: 20px;
    border-radius: 10px;
    padding: 52px 40% 52px 100px;

    .recruitmentTitle {
      height: auto;

      h2 {
        font-weight: 600;
      }
    }
    .recruitmentSubTitle {
      height: auto;
      p {
        color: ${(props) => props.theme.color.primaryColors.fontColor};
      }
    }

    .cvButton {
      height: auto;
    }
  }

  .opportunitiesContainer {
    height: auto;
    gap: 32px;

    .filtersWrapper {
      gap: 24px;
      height: auto;
      padding: 32px 100px 50px 100px;
      border-bottom: 1px solid #adb5bd;

      .button {
        width: 100%;

        button {
          width: 100%;
          justify-content: center;
          text-align: center;
        }
      }

      .simpleBtnWrapper {
        height: auto;
      }

      .iconInput {
        position: relative;
        height: auto;
        max-width: calc(25% - 24px);

        .inputContainer {
          p {
            display: none;
          }
        }

        input {
          padding-right: 36px;
        }

        svg {
          position: absolute;
          right: 15px;
          height: 18px;
          width: auto;

          path,
          circle {
            stroke: ${(props) => props.theme.color.primaryColors.secFontColor};
          }
        }
      }
    }

    .opportunitiesFlexBox {
      height: auto;
      gap: 30px;
      padding: 0 100px 50px 100px;
      flex-flow: row wrap;
      border-bottom: 1px solid #adb5bd;

      .opportunitiesCard {
        border: 1px solid #adb5bd;
        height: auto;
        border-radius: 10px;
        flex: 0 1 calc(25% - 23px);
        width: calc(25% - 23px);
        padding: 15px;
        gap: 24px;
        flex-shrink: 0;
        box-shadow: ${(props) => props.theme.lightShaddow};
        cursor: pointer;
        height: 265px;

        .opportunitieHeader {
          gap: 5px;

          h5 {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: none;
            font-weight: 600;
          }
          .opportunitieLocation {
            height: auto;
            p {
              color: ${(props) => props.theme.color.primaryColors.mediumPurple};
            }
            svg {
              height: 18px;
              margin-left: -5px;
              width: auto;

              path,
              circle {
                stroke: ${(props) => props.theme.color.primaryColors.mediumPurple};
              }
            }
          }
        }

        .opportunitiesArticle {
          overflow: hidden;

          p {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            color: ${(props) => props.theme.color.primaryColors.secFontColor};
          }

          &.noDescription {
            p {
              opacity: 0.36;
            }
          }
        }

        .opportunitiesLabel {
          height: auto;
          justify-content: flex-start;

          .labelWrapper {
            border-radius: 5px;
            background-color: ${(props) => props.theme.color.primaryColors.labelPurple};
            text-align: center;
            justify-content: center;
            padding: 12px 24px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            @media only screen and (max-width: 1450px) {
              padding: 8px 20px;
            }

            @media only screen and (max-width: 1024px) {
              padding: 6px 12px;
            }

            p {
              color: ${(props) => props.theme.color.primaryColors.white};
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .resultsNotFound {
        display: none;
      }

      &.noResults {
        padding: 25px 100px 50px 100px;

        .resultsNotFound {
          display: flex;

          h5 {
            font-weight: normal;
            color: ${(props) => props.theme.color.primaryColors.lightPurple};

            text-transform: none;
          }
        }
      }
    }

    .opportunitiesDetail {
      border-bottom: 1px solid #adb5bd;
      padding: 0 100px 50px 100px;
      gap: 24px;

      .sectionTitle {
        height: auto;

        h5 {
          text-transform: uppercase;
          font-weight: bold;
        }
      }
      .opportunitiesDetailContent {
        gap: 30px;
        height: 80vh;
        overflow: hidden;

        .opportunitieArticle {
          border: 1px solid #adb5bd;
          border-radius: 10px;
          padding: 32px;
          width: 70%;
          gap: 24px;
          height: calc(100% - 2px);

          * {
            transition: ${(props) => props.theme.transition};
          }

          .opportunitieHeader {
            height: auto;
            p {
              font-weight: bold;
              text-transform: uppercase;
            }
          }

          .opportunitieDescription {
            flex-grow: 1;
            overflow-y: auto;
            padding: 0 8px 0 0;

            p {
              color: ${(props) => props.theme.color.primaryColors.secFontColor};
              display: block;
              white-space: pre-line;
            }
          }

          .opportunitieLocation {
            gap: 8px;
            height: auto;

            p {
              color: ${(props) => props.theme.color.primaryColors.mediumPurple};
            }

            svg {
              height: 18px;
              margin-left: -5px;
              width: auto;

              path,
              circle {
                stroke: ${(props) => props.theme.color.primaryColors.mediumPurple};
              }
            }
          }

          .opportunitieApplyBtn {
            height: auto;
          }
        }

        .opportunitieList {
          border: 1px solid #adb5bd;
          border-radius: 10px;
          padding: 32px 6px;
          width: 30%;
          flex-grow: 1;
          overflow: hidden;
          height: calc(100% - 2px);

          .opportunitieListOverflow {
            overflow-y: auto;
            padding: 0 10px;
            gap: 30px;
          }

          .opportunitiesCard {
            border: 1px solid #adb5bd;
            height: auto;
            border-radius: 10px;
            padding: 15px;
            gap: 24px;
            flex-shrink: 0;
            box-shadow: ${(props) => props.theme.lightShaddow};
            cursor: pointer;
            height: auto;

            &:last-child {
              margin-bottom: 5px;
            }

            .opportunitieHeader {
              height: auto;
              gap: 5px;

              h5 {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                text-transform: none;
                font-weight: 600;
                font-size: 18px;
                line-height: 22px;
                user-select: none;

                @media only screen and (max-width: 1450px) {
                  font-size: 14px;
                }

                @media only screen and (max-width: 1024px) {
                  font-size: 12px;
                }
              }
              .opportunitieLocation {
                height: auto;

                p {
                  color: ${(props) => props.theme.color.primaryColors.mediumPurple};
                }
                svg {
                  height: 18px;
                  margin-left: -5px;
                  width: auto;

                  path,
                  circle {
                    stroke: ${(props) => props.theme.color.primaryColors.mediumPurple};
                  }
                }
              }
            }

            .opportunitiesArticle {
              p {
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                color: ${(props) => props.theme.color.primaryColors.secFontColor};
              }

              &.noDescription {
                p {
                  opacity: 0.36;
                }
              }
            }

            .opportunitiesLabel {
              height: auto;
              justify-content: flex-start;

              .labelWrapper {
                border-radius: 5px;
                background-color: ${(props) => props.theme.color.primaryColors.labelPurple};
                padding: 12px;
                text-align: center;
                padding: 12px 24px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                @media only screen and (max-width: 1450px) {
                  padding: 8px 20px;
                }

                @media only screen and (max-width: 1024px) {
                  padding: 6px 12px;
                }

                p {
                  color: ${(props) => props.theme.color.primaryColors.white};
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }

    .seeMoreBtn {
      height: auto;

      .button {
        width: auto;

        button {
          width: 100%;
          justify-content: center;
        }
      }
    }
  }

  @media only screen and (max-width: 1450px) {
    .recruitmentHeader {
      min-height: 250px;
      height: auto;
      padding: 40px 30% 40px 50px;
    }

    .opportunitiesContainer {
      .filtersWrapper {
        padding: 0px 50px 50px 50px;
        gap: 24px;
      }
      .opportunitiesDetail {
        padding: 0 50px 50px 50px;

        .opportunitiesDetailContent {
          .opportunitieArticle {
            gap: 16px;
          }

          .opportunitieList {
            padding: 16px 6px;

            .opportunitieListOverflow {
              gap: 32px;
            }
          }
        }
      }
      .opportunitiesFlexBox {
        padding: 0 50px 50px 50px;

        &.noResults {
          padding: 25px 50px 50px 50px;
        }

        .opportunitiesCard {
          flex: 0 1 calc(33.33% - 20px);
          width: calc(33.33% - 20px);
          height: 237px;

          .opportunitiesLabel {
            .labelWrapper {
              padding: 8px 20px;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    .recruitmentHeader {
      padding: 40px 20px 40px 20px;
    }

    .opportunitiesContainer {
      .filtersWrapper {
        padding: 0px 30px 50px 30px;
        gap: 16px;

        .iconInput {
          .dropDownContainer {
            max-height: 32px;

            .dropDownWrapper {
              .inputDropDownWrapper {
                height: 29px;
              }
            }
          }
        }
      }
      .opportunitiesFlexBox {
        padding: 0 30px 50px 30px;

        &.noResults {
          padding: 0px 30px 30px 30px;
        }

        .opportunitiesCard {
          gap: 16px;
          height: 184px;

          .opportunitiesArticle {
            p {
              -webkit-line-clamp: 2;
            }
          }
          .opportunitiesLabel {
            .labelWrapper {
              padding: 6px 12px;
            }
          }
        }
      }

      .opportunitiesDetail {
        padding: 0px 30px 50px 30px;

        .opportunitiesDetailContent {
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          height: auto;

          .opportunitieArticle {
            width: 100%;
            max-height: 80vh;
          }

          .opportunitieList {
            flex-direction: row;
            width: 100%;
            height: auto;
            padding: 8px;

            .opportunitieListOverflow {
              width: 100%;
              overflow-x: auto;
              overflow-y: hidden;
              flex-direction: row;
              height: auto;
              padding: 10px 0;
              gap: 32px;

              &::-webkit-scrollbar {
                display: none;
              }

              .opportunitiesCard {
                flex: 1 250px;
                min-width: 250px;
                gap: 16px;

                &:last-child {
                  margin-bottom: 0px;
                }

                .opportunitiesArticle {
                  display: none;
                }
              }
            }
          }
        }
      }
    }
  }

  /* MOBILE */
  @media only screen and (max-width: 815px) {
    padding: 0 20px;
    gap: 84px;

    .recruitmentHeader {
      padding: 32px 20px 32px 20px;
      height: auto;
      min-height: auto;
    }

    .opportunitiesContainer {
      .filtersWrapper {
        .iconInput {
          svg {
            height: 14px;
          }
        }
      }

      .seeMoreBtn {
        width: auto;
        padding: 0 20px;

        .button {
          width: 100%;

          button {
            width: 100%;
            justify-content: center;
          }
        }
      }

      .opportunitiesFlexBox {
        padding: 0 20px 50px 20px;
        column-gap: 16px;

        &.noResults {
          padding: 0px 20px 30px 20px;
        }

        .opportunitiesCard {
          flex: 0 1 calc(50% - 8px);
          width: calc(50% - 8px);
          border-radius: 5px;
          gap: 16px;
          min-height: 120px;
          height: auto;

          .opportunitiesArticle {
            display: none;
          }
        }
      }

      .opportunitiesDetail {
        padding: 0 20px 24px 20px;

        .opportunitiesDetailContent {
          .opportunitieArticle {
            padding: 16px;
          }

          .opportunitieList {
            .opportunitieListOverflow {
              gap: 16px;
              .opportunitiesCard {
                flex: 1 250px;
                min-width: 250px;
                gap: 16px;
              }
            }
          }
        }
      }

      .filtersWrapper {
        padding: 0 15px 24px 15px;
        gap: 16px;
        flex-wrap: wrap;
        .iconInput {
          width: calc(50% - 16px);
          flex: 1 calc(50% - 16px);
          max-width: unset;

          &:nth-child(1) {
            order: 3;
          }
          &:nth-child(2) {
            order: 1;
          }
          &:nth-child(3) {
            order: 2;
          }
        }
        .simpleBtnWrapper {
          order: 4;
          width: calc(50% - 16px);
          flex: 1 calc(50% - 16px);
        }
      }
    }
  }

  /* MOBILE MEDIUM*/
  @media only screen and (max-width: 650px) {
    .opportunitiesContainer {
      .filtersWrapper {
        .iconInput {
          width: 100%;
          flex: 1 100%;
        }
        .simpleBtnWrapper {
          width: 100%;
          flex: 1 100%;
        }
      }
      .opportunitiesFlexBox {
        .opportunitiesCard {
          flex: 1 100%;
          width: 100%;
        }
      }
    }
  }
  .scrollTarget {
    visibility: hidden;
  }
`;

export default class Recruitment extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();

    // Use the constructor with your `props.location.search`
    const queryParams = new URLSearchParams(props.render.location?.search);
    // Use the getters to grab a specific value
    const value = queryParams.get("id");
    // Ensure it's a number for safety
    const id = value != null ? Number(value) : null;

    if (id != null) {
      this.state.idSearch = id;
    }
  }

  getDefaultState = () => {
    return {
      ...this.getDefaultResultsState(),
    };
  };

  getDefaultResultsState = () => {
    return {
      idSearch: null,
      totalRows: null,
      results: [],
      areas: [],
      page: 1,
      pageSize: 12,
      selectedId: null,
      filter: null,
      selectedIds: [],
      function: "",
      location: "",
      keyword: "",
      scrollToSelected: false,
      hideLoadMore: false,
    };
  };

  componentDidMount() {
    super.componentDidMount();

    this.initializeSelect();
    this.getResults();
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(prevState.filter) !== JSON.stringify(this.state.filter) || prevState.pageSize != this.state.pageSize) {
      this.getResults();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  initializeSelect = () => {
    recruitmentRequestService
      .getRecruitmentRequestBusinessAreas()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((data) => {
        this.setState({
          areas: [...this.state.areas, ...(data ?? [])],
        });
      });
  };

  getResults = () => {
    this.setGlobalLoading(true);
    let params = {
      ...this.state.filter,
      ...{
        page: this.state.page,
        pageSize: this.state.pageSize,
      },
    };
    recruitmentRequestService
      .getRecruitmentRequestWebsiteSharingJobs(params)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((data) => {
        if (this.state.idSearch != null) {
          this.setState({
            results: data ?? [],
            totalRows: (data ?? [])[0]?.totalRows ?? 0,
            showDetails: true,
            hideLoadMore: true,
            showReturn: true,
            cardDetails: (data ?? []).find((r) => r.id == this.state.idSearch),
          });
        } else {
          this.setState({
            totalRows: (data ?? [])[0]?.totalRows ?? 0,
            results: data ?? [],
            hideLoadMore: ((data ?? [])[0]?.totalRows ?? 0) == (data ?? []).length ? true : false,
          });
        }
        this.setGlobalLoading(false);
      });
  };

  onSearch = () => {
    this.setState({
      ...{
        filter: {
          function: this.state.function,
          location: this.state.location,
          keyword: this.state.keyword,
          areas: this.state.filterAreas != null ? this.state.filterAreas.join(",") : "",
        },
        showDetails: false,
        hideLoadMore: ((this.state.results ?? [])[0]?.totalRows ?? 0) == (this.state.results ?? []).length ? true : false,
        showReturn: false,
        idSearch: null,
      },
    });
  };

  loadMore = () => {
    this.setState({
      pageSize: this.state.totalRows,
      hideLoadMore: true,
    });
  };

  cardDetails = (id) => {
    this.setState({
      showDetails: true,
      hideLoadMore: true,
      showReturn: true,
      cardDetails: this.state.results?.find((r) => r.id == id),
      pageSize: this.state.totalRows,
    });
  };

  returnList = () => {
    this.setState({
      showDetails: false,
      hideLoadMore: ((this.state.results ?? [])[0]?.totalRows ?? 0) == (this.state.results ?? []).length ? true : false,
      showReturn: false,
      idSearch: null,
    });
  };

  render() {
    return (
      <StyledRecruitment flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} data-aos="fade-up" data-aos-duration="1500">
        {/* HEADER */}
        <NanoFlex className="recruitmentHeader" flexDirection="column" alignItems="flex-start">
          <NanoFlex className="recruitmentTitle" justifyContent="flex-start">
            <Type.h2>{this.translation.recruitment.recruitmentHeaderTitle}</Type.h2>
          </NanoFlex>
          <NanoFlex className="recruitmentSubTitle" justifyContent="flex-start">
            <Type.p>{this.translation.recruitment.recruitmentHeaderText}</Type.p>
          </NanoFlex>
          <NanoFlex className="scrollTarget" id="opportunitiesBlock"></NanoFlex>
          <NanoFlex className="cvButton" justifyContent="flex-start" alignItems="flex-end">
            <a href={`${window.env.FrontEndUrl}/Candidatura`} target="blank">
              <SimpleButton darkPurple label={this.translation.recruitment.submitResume}></SimpleButton>
            </a>
          </NanoFlex>
        </NanoFlex>

        <NanoFlex className="opportunitiesContainer" flexDirection="column">
          {/* FILTERS */}
          <NanoFlex className="filtersWrapper">
            <NanoFlex className="iconInput">
              <MultipleSelectionDropdown
                placeholder={this.translation.recruitment.sector}
                options={this.state.areas}
                onChangeSelection={(values) => {
                  this.setState({
                    filterAreas: values.selected.map((s) => {
                      return s.id;
                    }),
                  });
                }}
              />
            </NanoFlex>
            <NanoFlex className="iconInput">
              <Input placeholder={this.translation.recruitment.keyword} onChangeAction={(val) => this.setState({ keyword: val })} />
              <SearchIcon />
            </NanoFlex>
            <NanoFlex className="iconInput">
              <Input placeholder={this.translation.recruitment.location} onChangeAction={(val) => this.setState({ location: val })} />
              <LocationIcon />
            </NanoFlex>
            <NanoFlex className="simpleBtnWrapper" alignItems="flex-end">
              <SimpleButton yellow label={this.translation.recruitment.searchOffers} clickAction={this.onSearch}></SimpleButton>
            </NanoFlex>
          </NanoFlex>

          {/* OPPORTUNITIES */}
          <NanoFlex className={`opportunitiesFlexBox ${this.state.results?.length == 0 ? "noResults" : ""} ${this.state.showDetails ? "hide" : ""}`} justifyContent="flex-start" alignItems="flex-start">
            {this.state.results?.map((d) => (
              <NanoFlex className="opportunitiesCard" flexDirection="column" data-aos="zoom-in" data-aos-delay="50" onClick={() => this.cardDetails(d.id)}>
                <NanoFlex className="opportunitieHeader" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                  <Type.h5 title={d.jobTitle} className="semiBold">
                    {d.jobTitle}
                  </Type.h5>
                  {d.location != null ? (
                    <NanoFlex className="opportunitieLocation" justifyContent="flex-start">
                      <LocationIcon />
                      <Type.p>{d.location}</Type.p>
                    </NanoFlex>
                  ) : (
                    <></>
                  )}
                </NanoFlex>
                <NanoFlex className={`opportunitiesArticle ${d.functionDescription != null && d.functionDescription != "" ? "" : "noDescription"}`} justifyContent="flex-start" alignItems="flex-start">
                  <Type.p title={d.functionDescription}>{d.functionDescription != null && d.functionDescription != "" ? d.functionDescription : this.translation.recruitment.noDescription}</Type.p>
                </NanoFlex>
                <NanoFlex className="opportunitiesLabel">
                  <NanoFlex className="labelWrapper">
                    <Type.p>
                      {d.areas != null
                        ? d.areas
                            .map(function (item) {
                              return item.name;
                            })
                            ?.join(", ") ?? "-"
                        : "-"}
                    </Type.p>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            ))}

            <NanoFlex className="resultsNotFound" justifyContent="flex-start">
              <Type.h5>{this.translation.recruitment.noResults}</Type.h5>
            </NanoFlex>
          </NanoFlex>

          {/* OPPORTUNITIES DETAIL */}
          <NanoFlex className={`opportunitiesDetail ${!this.state.showDetails ? "hide" : ""}`} flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <NanoFlex className="sectionTitle" justifyContent="flex-start">
              <Type.h5>ofertas disponíveis</Type.h5>
            </NanoFlex>
            <NanoFlex className="opportunitiesDetailContent">
              <NanoFlex className="opportunitieArticle" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <NanoFlex className="opportunitieHeader" justifyContent="flex-start">
                  <Type.p>{this.state.cardDetails?.jobTitle}</Type.p>
                </NanoFlex>
                {this.state.cardDetails?.location != null ? (
                  <NanoFlex className="opportunitieLocation" justifyContent="flex-start">
                    <LocationIcon />
                    <Type.p>{this.state.cardDetails?.location}</Type.p>
                  </NanoFlex>
                ) : (
                  <></>
                )}
                <NanoFlex className="opportunitieDescription" justifyContent="flex-start" alignItems="flex-start">
                  <Type.p>{this.state.cardDetails?.functionDescription != null && this.state.cardDetails?.functionDescription != "" ? this.state.cardDetails?.functionDescription : this.translation.recruitment.noDescription}</Type.p>
                </NanoFlex>
                <NanoFlex
                  className="opportunitieApplyBtn"
                  justifyContent="flex-start"
                  onClick={() => {
                    window.open(`${window.env.FrontEndUrl}/Candidatura?recruitmentRequestId=${this.state.cardDetails?.id}`, "_blank", "noopener,noreferrer");
                  }}>
                  <SimpleButton label={this.translation.recruitment.submit}></SimpleButton>
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="opportunitieList" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                <NanoFlex className="opportunitieListOverflow" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
                  {this.state.results?.map((r) => (
                    <NanoFlex className="opportunitiesCard" flexDirection="column" onClick={() => this.cardDetails(r.id)}>
                      <NanoFlex className="opportunitieHeader" flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                        <Type.h5 className="semiBold">{r.jobTitle}</Type.h5>
                        {r.location != null ? (
                          <NanoFlex className="opportunitieLocation" justifyContent="flex-start">
                            <LocationIcon />
                            <Type.p>{r.location}</Type.p>
                          </NanoFlex>
                        ) : (
                          <></>
                        )}
                      </NanoFlex>
                      <NanoFlex className={`opportunitiesArticle ${r.functionDescription != null && r.functionDescription != "" ? "" : "noDescription"}`} justifyContent="flex-start" alignItems="flex-start">
                        <Type.p>{r.functionDescription != null && r.functionDescription != "" ? r.functionDescription : this.translation.recruitment.noDescription}</Type.p>
                      </NanoFlex>
                      <NanoFlex className="opportunitiesLabel">
                        <NanoFlex className="labelWrapper">
                          <Type.p>
                            {r.areas != null
                              ? r.areas
                                  .map(function (item) {
                                    return item.name;
                                  })
                                  ?.join(", ") ?? "-"
                              : "-"}
                          </Type.p>
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                  ))}
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>

          {/* SEE MORE BUTTON | HIDE WHEN DETAILS ARE SHOWING*/}
          <NanoFlex className={`seeMoreBtn ${this.state.hideLoadMore ? "hide" : ""}`}>
            <SimpleButton darkPurple label={this.translation.recruitment.viewMoreOffers} clickAction={this.loadMore}></SimpleButton>
          </NanoFlex>

          {/* RETURN TO LIST BUTTON | HIDE WHEN LIST IS SHOWING*/}
          <NanoFlex className={`seeMoreBtn ${!this.state.showReturn ? "hide" : ""}`}>
            <SimpleButton darkPurple label={this.translation.recruitment.returnList} clickAction={this.returnList}></SimpleButton>
          </NanoFlex>
        </NanoFlex>
      </StyledRecruitment>
    );
  }
}
